import React, { Suspense, lazy, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import CrescentLandingPage from './pages/CrescentLandingPage';
import IntelligenceAuth from './pages/IntelligenceAuth';
import GoogleAuthCallback from './pages/GoogleAuthCallback';
import { AuthProvider } from './context/AuthContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import './styles/crescent-system.css';
import './styles/crescent-research.css';
import './styles/crescent-accessibility.css';

const IntelligenceConsole = lazy(() => import('./pages/IntelligenceConsole'));
const MarketsPage = lazy(() => import('./pages/MarketsPage'));
const PublicInfoPage = lazy(() => import('./pages/PublicInfoPage'));

function AppRouter() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash && !location.hash.includes('session_id=')) {
      const id = decodeURIComponent(location.hash.slice(1));
      const timer = setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'instant', block: 'start' }), 80);
      return () => clearTimeout(timer);
    }
    if (!location.pathname.startsWith('/intelligence')) window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);
  if (location.hash?.includes('session_id=')) return <GoogleAuthCallback />;
  return <ErrorBoundary key={location.pathname.split('/')[1]}><Suspense fallback={<div className="ci-loading" data-testid="route-loading">Opening Crescent…</div>}><Routes>
    <Route path="/" element={<CrescentLandingPage />} />
    <Route path="/platform" element={<Navigate to="/#how-it-works" replace />} />
    <Route path="/services" element={<Navigate to="/#how-it-works" replace />} />
    <Route path="/how-it-works" element={<Navigate to="/#how-it-works" replace />} />
    <Route path="/pricing" element={<Navigate to="/#pricing" replace />} />
    <Route path="/about" element={<PublicInfoPage type="about" />} />
    <Route path="/contact" element={<PublicInfoPage type="contact" />} />
    <Route path="/privacy" element={<PublicInfoPage type="privacy" />} />
    <Route path="/terms" element={<PublicInfoPage type="terms" />} />
    <Route path="/markets" element={<MarketsPage />} />
    <Route path="/markets/:symbol" element={<MarketsPage />} />
    <Route path="/intelligence/auth" element={<IntelligenceAuth />} />
    <Route path="/intelligence/*" element={<IntelligenceConsole />} />
    <Route path="*" element={<PublicInfoPage type="not-found" />} />
  </Routes></Suspense></ErrorBoundary>;
}
export default function App() {
  return <div className="App"><AuthProvider><BrowserRouter><AppRouter /></BrowserRouter></AuthProvider></div>;
}